import React from 'react';

const STEPS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const NEON_BLUE = '#1F51FF';

export default function AgendaProgressBar({ value = 0, editable = false, onChange }) {
  return (
    <div className="space-y-2">
      <div className="relative w-full h-7 bg-zinc-700 rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-300"
          style={{ width: `${value}%`, backgroundColor: NEON_BLUE, boxShadow: value > 0 ? `0 0 8px ${NEON_BLUE}` : 'none' }}
        />
        <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-white">
          {value}%
        </div>
      </div>
      {editable && (
        <div className="flex flex-wrap gap-1">
          {STEPS.map(s => (
            <button
              key={s}
              type="button"
              onClick={() => onChange(s)}
              className={`px-2 py-1 rounded text-xs font-medium transition-colors ${value === s ? 'text-white' : 'bg-zinc-800 text-zinc-400 hover:bg-zinc-700'}`}
              style={value === s ? { backgroundColor: NEON_BLUE } : undefined}
            >
              {s}%
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export function AgendaProgressBarVertical({ value = 0 }) {
  return (
    <div className="flex flex-col items-center gap-1" title={`${value}% concluído`}>
      <div className="relative w-3 h-10 bg-zinc-700 rounded-full overflow-hidden">
        <div
          className="absolute bottom-0 left-0 w-full rounded-full transition-all duration-300"
          style={{ height: `${value}%`, backgroundColor: NEON_BLUE, boxShadow: value > 0 ? `0 0 6px ${NEON_BLUE}` : 'none' }}
        />
      </div>
      <span className="text-[10px] text-zinc-400">{value}%</span>
    </div>
  );
}
